import mutations from '@/store/modules/checkout/mutations'
import { DefaultShipping, DefaultBilling, addressAssest } from '@/store/modules/checkout/defaultValues'

mutations.setShipToStore = (state, bolVal) => {
  state.shipToStore = bolVal
}

mutations.setShipStoreId = (state, storeId) => {
  state.shipStoreId = storeId
}

mutations.setInvoice = (state, invoice) => {
  state.invoice = invoice
}

mutations.updCart = (state, cart) => {
  // payment methods
  state.paymentMethods = cart.available_payment_methods
  state.paymentMethod.current = cart.selected_payment_method.code || ''
  // billing address
  if (cart.billing_address && cart.billing_address.city) {
    state.billingAddress = Object.assign({}, addressAssest({ ...DefaultBilling, ...cart.billing_address }) || { ...DefaultBilling })
  }
  if (cart.shipping_addresses && cart.shipping_addresses.length) {
    const shippingAddress = cart.shipping_addresses[0]
    // shipping methods
    state.shippingMethods = shippingAddress.available_shipping_methods.filter(item => item.available)
    state.shippingMethod = shippingAddress.selected_shipping_method ? shippingAddress.selected_shipping_method.carrier_code : null
    // shipping address
    state.shippingAddress = addressAssest({ ...DefaultShipping, ...shippingAddress }) || { ...DefaultShipping }
    delete state.shippingAddress['available_shipping_methods']
  } else {
    state.shippingMethods = []
  }

  if (cart.email) { state.email = cart.email }
  if (cart.invoice) { state.invoice = cart.invoice }

  state.cart = cart
}

export default {
  ...mutations
}
